export default defineNuxtPlugin((nuxtApp) => {
	return {
		provide: {
			getRelativeTimeDifference: (firstDate, secondDate) => {
				const date1 = new Date(firstDate)
				const date2 = new Date(secondDate)

				const diffInMs = date2 - date1

				const diffInSeconds = diffInMs / 1000
				const diffInMinutes = diffInMs / (1000 * 60)
				const diffInHours = diffInMs / (1000 * 60 * 60)
				const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
				const diffInMonths = diffInDays / 30
				const diffInYears = diffInDays / 365

				let unit
				let value

				if (Math.abs(diffInYears) >= 1) {
					unit = 'year'
					value = diffInYears
				} else if (Math.abs(diffInMonths) >= 1) {
					unit = 'month'
					value = diffInMonths
				} else if (Math.abs(diffInDays) >= 1) {
					unit = 'day'
					value = diffInDays
				} else if (Math.abs(diffInHours) >= 1) {
					unit = 'hour'
					value = diffInHours
				} else if (Math.abs(diffInMinutes) >= 1) {
					unit = 'minute'
					value = diffInMinutes
				} else {
					unit = 'second'
					value = diffInSeconds
				}

				const rtf = new Intl.RelativeTimeFormat('sk-SK', { numeric: 'auto' })
				const formattedDiff = rtf.format(Math.floor(value), unit)

				return formattedDiff
			}
		}
	}
})
